<div class="card-body">
    <canvas height="100px" id="basic_radar_chart"></canvas>
</div>